import React from 'react';
import {Container} from "react-bootstrap";

export default function Footer(props) {
    return (
        <footer className={`inic-footer mt-auto py-4 ${props.minimal ? "inic-footer--seamless" : ""}`}>
          <Container>
            <div className='d-flex align-items-center justify-content-md-between flex-md-nowrap flex-wrap justify-content-center gap-2'>
              <p className='mb-0 label-mono'>Candidate Portal</p>
              <div className='inic-footer-contact d-flex align-items-center flex-wrap justify-content-center gap-3'>
                <a href="tel:+917961916000" className='inic-footer-contact-link'>
                  <i className="bx bx-phone" /> +91 79 6191 6000
                </a>
                <a href="mailto:hr@indianic.com" className='inic-footer-contact-link'>
                  <i className="bx bx-envelope" /> hr@indianic.com
                </a>
              </div>
              <p className='mb-0'>IndiaNIC Infotech Limited © {new Date().getFullYear()}</p>
            </div>
          </Container>
        </footer>
    )
}
